import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/catch";
import {errorConsultandoKeyCaptcha, keyCaptchaConsultada} from "./actions";
import {catchError, map, mergeMap} from "rxjs/operators";
import * as types from "./types";
import {ofType} from "redux-observable";
import {RequestWrapper} from "../../../request/RequestWrapper/RequestWrapper";

export const consultarKeyCaptchaEpic = action$ => {
  return action$.pipe(
    ofType(types.CONSULTAR_KEY_CAPTCHA),
    mergeMap(() => RequestWrapper
      .get(`/autorizacion/recaptcha/site-key`)
      .pipe(map(response => keyCaptchaConsultada(response)),
        catchError((error) => [errorConsultandoKeyCaptcha(error)]),
      )));
};
